// Importações de bibliotecas e componentes necessários
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'primevue/resources/themes/nova/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faUserShield } from '@fortawesome/free-solid-svg-icons'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import AutoComplete from 'primevue/autocomplete';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import Calendar from 'primevue/calendar';
import money from 'v-money';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import InputMask from 'primevue/inputmask';
import InlineMessage from 'primevue/inlinemessage';
import SimpleVueValidation from 'simple-vue-validator';
import Message from 'primevue/message';
import ErrorList from './components/global/ErrorList'
import Panel from 'primevue/panel';
import Checkbox from 'primevue/checkbox';
import FileUpload from 'primevue/fileupload';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Card from 'primevue/card';
import SplitButton from 'primevue/splitbutton';
import PrimeVue from 'primevue/config';
import axios from 'axios';
import MultiSelect from 'primevue/multiselect';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Maska from 'maska';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Editor from 'primevue/editor';
import Chip from 'primevue/chip';
import VueRecaptcha from 'vue-recaptcha';
import VueGtag from "vue-gtag";
import Tooltip from 'primevue/tooltip';
import BlockUI from 'primevue/blockui';

import 'regenerator-runtime/runtime'

// Importação de estilos personalizados após todos os outros estilos
import './assets/css/variables.css';
import './assets/css/login.css';
import './assets/css/app.css';

// Adiciona uma função ao protótipo do Vue para verificar se deve usar Bootstrap
Vue.prototype.$useBootstrap = function () {
  return !this.$route.meta.noBootstrap;
}

// Função assíncrona para inicializar a aplicação
async function bootstrap() {

  // Faz uma requisição para obter dados de configuração do backend
  const response = await axios.get('/backend.json');
  Vue.prototype.$configAppData = response.data;
  Vue.prototype.$baseURLSistema = response.data.baseUrl;
  Vue.prototype.$apresentacao = response.data.apresentacao ? response.data.apresentacao : false;
  Vue.prototype.$baseUrlExtrato = response.data.baseUrlExtrato ? response.data.baseUrlExtrato : null;

  // Define a URL base para axios
  axios.defaults.baseURL = response.data.baseUrl;

  // Adiciona ícones ao FontAwesome
  library.add(faTimes, faUser, faUserPlus, faSignInAlt, faSignOutAlt, faUserShield)

  // Registra componentes globais do Vue
  Vue.component('font-awesome-icon', FontAwesomeIcon)
  Vue.component('DataTable', DataTable);
  Vue.component('Column', Column);
  Vue.component('Button', Button);
  Vue.component('InputText', InputText);
  Vue.component('AutoComplete', AutoComplete);
  Vue.component('Dropdown', Dropdown);
  Vue.component('RadioButton', RadioButton);
  Vue.component('Calendar', Calendar);
  Vue.component('Toast', Toast);
  Vue.component('Dialog', Dialog);
  Vue.component('InputMask', InputMask);
  Vue.component('Message', Message);
  Vue.component('InlineMessage', InlineMessage);
  Vue.component('Panel', Panel);
  Vue.component('Checkbox', Checkbox);
  Vue.component('FileUpload', FileUpload);
  Vue.component('TabView', TabView);
  Vue.component('TabPanel', TabPanel);
  Vue.component('Card', Card);
  Vue.component('SplitButton', SplitButton);
  Vue.component('MultiSelect', MultiSelect);
  Vue.component('BlockUI', BlockUI);
  Vue.component('Accordion', Accordion);
  Vue.component('AccordionTab', AccordionTab);
  Vue.component('Badge', Badge);
  Vue.component('Editor', Editor);
  Vue.component('Chip', Chip);
  Vue.component('VueRecaptcha', VueRecaptcha);
  Vue.component('Accordion', Accordion);
  Vue.component('AccordionTab', AccordionTab);

  // Registra diretivas globais do Vue
  Vue.directive('badge', BadgeDirective);
  Vue.directive('tooltip', Tooltip);

  // Registra o componente global ErrorList
  Vue.component('ErrorList', ErrorList);

  // Configurações do PrimeVue
  Vue.use(PrimeVue, {
    locale: {
      accept: 'Aceitar',
      reject: 'Rejeitar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Do", "Seg", "Te", "Qua", "Qui", "Sex", "Sa"],
      dayNamesMin: ["Do", "Seg", "Te", "Qua", "Qui", "Sex", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      weekHeader: 'Se',
      dateFormat: 'dd/mm/yyyy',
      weak: 'Mês'
    }
  });

  // Configurações adicionais de plugins
  Vue.use(money, { precision: 4 })
  Vue.use(SimpleVueValidation);
  Vue.use(ToastService);
  Vue.use(ToastService);
  Vue.use(Maska);
  Vue.use(VueGtag, {
    config: { id: "G-X1NP1TJ2LG" }
  }, router);

  // Adiciona moment ao protótipo do Vue
  Vue.prototype.moment = moment;

  // Desativa a dica de produção do Vue
  Vue.config.productionTip = false

  // Cria e monta a instância principal do Vue
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

// Chama a função bootstrap para inicializar a aplicação
bootstrap();

